import "unfetch/polyfill";

export default function findFeatureGroups(apiUrl, apiKey) {
  return new Promise(function(resolve, reject) {
    fetch(apiUrl + "feature_group?apiKey=" + apiKey)
      .then(r => r.json())
      .then(data => {
        resolve(data);
      })
      .catch(reason => {
        reject(reason);
      });
  });
}
